<!-- eslint-disable max-len -->
<template>
    <div class="incubator-apply">
        <div
            v-if="isFinish"
            class="deadline"
        >
            {{ $t('IncubatorApply.index.deadline') }}
        </div>
        <div
            v-else
            class="web-content"
        >
            <div class="process-structure">
                <div class="apply-process-body">
                    <div class="process-page-title-row">
                        <div class="process-page-title">
                            {{ $t('IncubatorApply.index.title') }}
                        </div>
                    </div>
                    <v-stepper
                        alt-labels
                        :value="nowStep"
                        class="stepper"
                    >
                        <v-stepper-header>
                            <v-stepper-step
                                :color="stepColor(0)"
                                :complete="nowStep > 0"
                                step="0"
                            >
                                {{ $t('IncubatorApply.index.stepper[0]') }}
                            </v-stepper-step>

                            <v-divider />

                            <v-stepper-step
                                :color="stepColor(1)"
                                :complete="nowStep > 1"
                                step="1"
                            >
                                {{ $t('IncubatorApply.index.stepper[1]') }}
                            </v-stepper-step>

                            <v-divider />

                            <v-stepper-step
                                :color="stepColor(2)"
                                :complete="nowStep > 2"
                                step="2"
                            >
                                {{ $t('IncubatorApply.index.stepper[2]') }}
                            </v-stepper-step>

                            <v-divider />

                            <v-stepper-step
                                :color="stepColor(3)"
                                :complete="nowStep > 3"
                                step="3"
                            >
                                {{ $t('IncubatorApply.index.stepper[3]') }}<br> {{ $t('IncubatorApply.index.stepper[4]') }}
                            </v-stepper-step>

                            <v-divider />

                            <v-stepper-step
                                :color="stepColor(4)"
                                :complete="nowStep > 4"
                                step="4"
                            >
                                {{ $t('IncubatorApply.index.stepper[5]') }}
                            </v-stepper-step>
                        </v-stepper-header>
                    </v-stepper>
                    <!-- Child Router -->
                    <router-view />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import API from '@/api';
import _ from 'lodash';

export default {
    components: {},
    data() {
        return {
            session: '',
        };
    },
    computed: {
        ...mapGetters('mAuth', ['isLogin']),
        applyId() {
            return this.$route.params.id;
        },
        nowStep() {
            switch (this.$route.name) {
                case 'IncubatorConsent':
                    return 0;
                case 'IncubatorTeamData':
                    return 1;
                case 'IncubatorProposal':
                    return 2;
                case 'IncubatorConfirm':
                    return 3;
                case 'IncubatorComplete':
                    return 4;
                default:
                    return 0;
            }
        },
        isFinish() {
            return false;
        },
    },
    created() {
        this.init();
    },
    mounted() { },
    methods: {
        ...mapMutations('mNotification', ['setAlert']),
        ...mapMutations('mLoading', ['setLoading']),
        ...mapActions('mIncubatorApply', ['loadApply']),
        async init() {
            try {
                const res = await API.Setting.PublicInfo();
                this.session = res.data.IncubatorSession.session;
            } catch (e) {
                this.handleError({
                    message: e || this.$t('alertMessage.session-error'),
                    color: 'error',
                });
            }
            const check = await this.checkUserApply();
            if (!this.isLogin) {
                this.setAlert({
                    message: this.$t('alertMessage.login'),
                    color: 'primary',
                });
                this.$router.replace({ name: 'Login' });
                return;
            }
            if (!check) {
                this.setAlert({
                    message: this.$t('alertMessage.Sign-up'),
                    color: 'primary',
                });
                this.$router.push({ name: 'UserIncubator' });
                return;
            }
            if (this.applyId === 'new') {
                return;
            }
            this.loadApply(this.applyId);
        },
        stepColor(val) {
            if (this.nowStep >= val) {
                return '#F97E2B';
            }
            return '';
        },
        async checkUserApply() {
            if (this.applyId !== 'new') {
                return true;
            }
            this.setLoading(true);
            const res = await this.getUserIncubatorList();
            const list = res.data.raw;
            const applyList = _.filter(list, (o) => o.session === this.session);
            this.setLoading(false);
            if (applyList.length > 0) {
                return false;
            }
            return true;
        },
        async getUserIncubatorList() {
            return API.IncubatorApply
                .PrivateList({
                    params: {
                        limit: 10, // default: 10 可不帶
                        offset: 0, // 從第幾比開始取
                    },
                });
        },
    },
};
</script>

<style lang="scss">
@import '@/scss/apply.scss';

.incubator-apply {
  display: flex;
  justify-content: center;
}

.deadline{
  padding: 50px 10px;
}
</style>
